function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M20.071619,17.8699733 C13.5695238,17.8699733 8.29942857,18.17984 8.29942857,21.0634667 C8.29942857,23.9470933 13.5695238,24.25696 20.071619,24.25696 C26.5729524,24.25696 31.8430476,23.9470933 31.8430476,21.0634667 C31.8430476,18.17984 26.5729524,17.8699733 20.071619,17.8699733 Z M20.071619,0.149333333 C13.5695238,0.149333333 8.29942857,0.458453333 8.29942857,3.34208 C8.29942857,6.22645333 13.5695238,6.53557333 20.071619,6.53557333 C26.5729524,6.53557333 31.8430476,6.22645333 31.8430476,3.34208 C31.8430476,0.458453333 26.5729524,0.149333333 20.071619,0.149333333 Z M12.4015238,9.00928 C5.90019048,9.00928 0.630095238,9.31914667 0.630095238,12.2027733 C0.630095238,15.0871467 5.90019048,15.3962667 12.4015238,15.3962667 C18.903619,15.3962667 24.1737143,15.0871467 24.1737143,12.2027733 C24.1737143,9.31914667 18.903619,9.00928 12.4015238,9.00928 Z M12.4015238,26.7306667 C5.90019048,26.7306667 0.630095238,27.0397867 0.630095238,29.92416 C0.630095238,32.8077867 5.90019048,33.1176533 12.4015238,33.1176533 C18.903619,33.1176533 24.1737143,32.8077867 24.1737143,29.92416 C24.1737143,27.0397867 18.903619,26.7306667 12.4015238,26.7306667 Z",
  id: "a"
}), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#FFEA9F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFD166",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-783.000000, -184.000000)"
}, React.createElement("g", {
  transform: "translate(783.000000, 184.000000)"
}, React.createElement("g", null, React.createElement("mask", {
  id: "c",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("g", null), React.createElement("path", {
  d: "M20.071619,17.8699733 C13.5695238,17.8699733 8.29942857,18.17984 8.29942857,21.0634667 C8.29942857,23.9470933 13.5695238,24.25696 20.071619,24.25696 C26.5729524,24.25696 31.8430476,23.9470933 31.8430476,21.0634667 C31.8430476,18.17984 26.5729524,17.8699733 20.071619,17.8699733 Z M20.071619,0.149333333 C13.5695238,0.149333333 8.29942857,0.458453333 8.29942857,3.34208 C8.29942857,6.22645333 13.5695238,6.53557333 20.071619,6.53557333 C26.5729524,6.53557333 31.8430476,6.22645333 31.8430476,3.34208 C31.8430476,0.458453333 26.5729524,0.149333333 20.071619,0.149333333 Z M12.4015238,9.00928 C5.90019048,9.00928 0.630095238,9.31914667 0.630095238,12.2027733 C0.630095238,15.0871467 5.90019048,15.3962667 12.4015238,15.3962667 C18.903619,15.3962667 24.1737143,15.0871467 24.1737143,12.2027733 C24.1737143,9.31914667 18.903619,9.00928 12.4015238,9.00928 Z M12.4015238,26.7306667 C5.90019048,26.7306667 0.630095238,27.0397867 0.630095238,29.92416 C0.630095238,32.8077867 5.90019048,33.1176533 12.4015238,33.1176533 C18.903619,33.1176533 24.1737143,32.8077867 24.1737143,29.92416 C24.1737143,27.0397867 18.903619,26.7306667 12.4015238,26.7306667 Z",
  fill: "url(#b)",
  mask: "url(#c)"
})))));

const SvgSereneHeaderIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "32px",
  height: "34px",
  viewBox: "0 0 32 34",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSereneHeaderIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serene-header-icon.0fb0fb51.svg";
export { ForwardRef as ReactComponent };